// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"3d36dadc","787":"ed3d4ef5","983":"853bfdac"}[chunkId] + ".chunk.js";
};